import React from 'react';
import ReactDOM from 'react-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { GWPandLoyaltyGeoSettings } from '../../../../../globals';
import { usePromise } from '../../../../../templates/_shared/react-hooks';
import { loyaltyState } from './loyaltyState';
import RewardsCarousel from './RewardsCarousel';
import { Customer } from '../../../../../utils/environment';
import { isLoopReturnsActive } from 'src/scripts/utils/cart';

let RewardsAccessPage = ({ options }: { options?: RewardsWidgetOptions }) => {
  const { data } = usePromise(() => GWPandLoyaltyGeoSettings());
  const pointsBalance = toJS(loyaltyState.pointsBalance);
  const isCustomer = !!Customer.id;

  const shouldHideRedeemButton = options?.shouldHideRedeemButton !== undefined ? options.shouldHideRedeemButton : true;
  const redeemButtonText = data?.redeemButtonText || undefined;
  const widgetTitle = data?.accessPageWidgetTitle;
  const widgetDescription = data?.accessPageWidgetDescription;

  if (!data || data?.shouldHideWidget || isLoopReturnsActive()) return null;

  return (
    <>
      {!options?.hideHeadings && (
        <div className="section-info">
          <h2 className="title h2 center">{widgetTitle}</h2>
          {widgetDescription && (
            <span className="body subtitle" dangerouslySetInnerHTML={{ __html: widgetDescription }} />
          )}
          <br />
          {isCustomer && (
            <p className="text-center points-balance">
              <span>{pointsBalance} points</span> available
            </p>
          )}
        </div>
      )}
      <RewardsCarousel shouldHideRedeemButton={shouldHideRedeemButton} redeemButtonText={redeemButtonText} />
    </>
  );
};

RewardsAccessPage = observer(RewardsAccessPage);
export { RewardsAccessPage };

const renderRewardsAccessPage = (options?: RewardsWidgetOptions) => {
  const mountNode = document.querySelector('[react-render-target="ll-rewards-widget-container"]');

  if (mountNode) ReactDOM.render(<RewardsAccessPage options={options} />, mountNode);
  else console.warn('missing render target: RewardsAccessPage');
};

export const initRenderRewardsAccessPage = (options?: RewardsWidgetOptions) => {
  renderRewardsAccessPage(options);
};

export interface RewardsWidgetOptions {
  hideHeadings: boolean;
  shouldHideRedeemButton: boolean;
}
